import { MouseEvent, useCallback, useContext } from 'react';
import styled from 'styled-components';
import { MenuContext } from '../Menu';
import { MenuItemRoot } from '../styles';
import { MenuItemProps } from '../types';

const MenuItemComponent = (props: MenuItemProps) => {
    const { onClick, disableClose, ...other } = props;
    const menuContext = useContext(MenuContext);

    const handleClick = useCallback(
        (event: MouseEvent<any>) => {
            event.preventDefault();
            event.stopPropagation();

            if (!disableClose && menuContext) {
                menuContext.onClose();
            }

            onClick?.(event);
        },
        [onClick, disableClose, menuContext],
    );

    return (
        <MenuItemRoot
            {...other}
            onClick={handleClick}
            tabIndex={1}
            px={{ xs: 1.5, md: 2 }}
            py={{ xs: 1.5, md: 1.5 }}
        />
    );
};

export const MenuItem = styled(MenuItemComponent).withConfig({ displayName: 'MenuItem' })``;
